import ActivityLog from '@components/activityLog/ActivityLog'
import { useMembershipProfileContext } from '@contexts/membership/MembershipProfileContext'
import { useAppSelector } from '@store/hooks'
import { selectMembershipProfileById } from '@store/membership/MembershipProfileReducer'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Flex } from 'antd'

const SubscriptionActivitiesSection = () => {
  const { id } = useMembershipProfileContext()
  const membershipProfile = useAppSelector(selectMembershipProfileById(id))

  if (!membershipProfile) return null

  return (
    <Flex vertical gap={8}>
      <PageTitle
        level={5}
        title="Subscription's Activities"
        style={{ margin: 0 }}
      />
      {membershipProfile.subscription && (
        <ActivityLog.Timeline
          title=""
          entity="membership-subscription"
          entityId={membershipProfile.subscription}
        />
      )}
    </Flex>
  )
}

export default SubscriptionActivitiesSection
